import { Injectable } from '@angular/core';
import { IPolicyHoldersInput } from '@nibtravel/shared/util/models';
import { IPlanState } from '../model/plans-state-model';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class CancellationHelper {
  setConfigWithDefaultImplict(
    state: IPlanState,
    planId: number,
    policyHolders: IPolicyHoldersInput[]
  ) {
    // To avoid duplication and wrong dynamic values (when switching between plans)
    // Getting the original data from the api to make the new state object
    const optionSummary = cloneDeep(state.apiPlanOptions)[planId];
    const config = optionSummary.cancellationOption;
    let implicitCancellationValue: number | undefined;
    if (config) {
      const adults = policyHolders.filter(
        (ph) => !ph.isDependent && Boolean(ph.age)
      );
      const valuePerAdult =
        adults.length * config.preCoverCancellationCoverLimitPerPolicyHolder;
      implicitCancellationValue =
        valuePerAdult > config.preCoverCancellationCoverLimitPerPolicy
          ? config.preCoverCancellationCoverLimitPerPolicy
          : valuePerAdult;

      // Only add a value if it doesn't already exist
      if (
        !config.cancellationCoverLimits.some(
          (limit) => limit.cancellationCoverLimit === implicitCancellationValue
        )
      ) {
        config.cancellationCoverLimits.push({
          cancellationCoverLimit: implicitCancellationValue,
          name: implicitCancellationValue.toString(),
          isCancellationCoverUnlimited: false,
        });

        // Ensure the limits are in the correct order to be displayed
        config.cancellationCoverLimits = config.cancellationCoverLimits.sort(
          (a, b) => a.cancellationCoverLimit - b.cancellationCoverLimit
        );
      }

      optionSummary.cancellationOption = config;
    }

    return { optionSummary, implicitCancellationValue };
  }
}
